import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { GenerateInputFormComponent } from './generate-input-form/generate-input-form.component';
import { GenerateInputErrorMessageComponent } from './generate-input-error-message/generate-input-error-message.component';
import { GENERATE_INPUT_TYPE } from '../constant';
import { GenerateService } from '../../generate.service';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import { LOADING_KEY } from 'src/app/shared/constant/constant';
import { MessageData, ToastMessageData } from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';

@Component({
  selector: 'app-generate-input-information',
  templateUrl: './generate-input-information.component.html',
  styleUrls: ['../generate-input.component.scss'],
})

/**
 * 入力情報
 */
export class GenerateInputInformationComponent implements OnInit {
  /** 入力エラーメッセージ */
  @ViewChild(GenerateInputErrorMessageComponent)
  generateInputErrorMessageComponent: GenerateInputErrorMessageComponent;

  /** 入力フォーム */
  @ViewChild(GenerateInputFormComponent)
  generateInputFormComponent: GenerateInputFormComponent;

  // 更新対象ID
  @Output() reloadID = new EventEmitter<string>();

  @Output() closeModal = new EventEmitter<void>();

  // 登録種別
  inputType: string;

  // REST APIエンドポイント
  endPoint: string;

  // 対象データのID
  pkeyId: string;
  templateId: number;
  endPointGenerateDisplay: string;

  constructor(
    private generateService: GenerateService,
    private loadingState: LoadingState,
    private messageData: MessageData,
    private commonService: CommonService
  ) { }

  ngOnInit(): void { }

  /**
   * 入力情報表示
   * @param inputType 登録種別（新規:new、編集:edit、複製:duplicate）
   * @param endPointInput 入力項目生成用エンドポイント
   * @param endPoint REST APIエンドポイント
   * @param templateId テンプレートID
   * @param pkeyId 対象データのID
   * @param inputQueryParameters 入力項目生成時の絞り込み条件
   * @param endPointWorkInputCheck 業務入力チェックエンドポイント
   */
  public initial(
    inputType: string,
    endPointInput: string,
    endPointGenerateDisplay: string,
    endPoint: string,
    templateId: number,
    pkeyId?: string,
    inputQueryParameters?: Object,
    endPointWorkInputCheck?: string
  ) {
    // 登録種別をプロパティに格納
    this.inputType = inputType;
    this.endPointGenerateDisplay = endPointGenerateDisplay
    // エンドポイントをプロパティに格納
    this.endPoint = endPoint;

    // 対象IDをプロパティに格納
    this.pkeyId = pkeyId;
    this.templateId = templateId;
    // 入力エラーメッセージをクリア
    this.generateInputErrorMessageComponent.clear();

    // 入力フォーム表示
    this.generateInputFormComponent.initial(
      inputType,
      endPointInput,
      endPointGenerateDisplay,
      templateId,
      pkeyId,
      inputQueryParameters,
      endPointWorkInputCheck
    );
  }

  /**
   * 入力エラー情報出力
   * @param generateInputErrorInformation 入力フォームエラー情報
   */
  public outputGenerateInputErrorInformation(
    generateInputErrorInformation: any
  ) {
    // 入力フォームエラー情報を出力
    this.generateInputErrorMessageComponent.initial(
      generateInputErrorInformation
    );
  }

  /**
   * 入力フォーム情報登録
   * @param generateInputInformation 入力フォーム情報
   */
  public insertGenerateInputInformation(generateInputInformation: any) {
    // 登録種別を判定
    if (
      GENERATE_INPUT_TYPE.NEW == this.inputType ||
      GENERATE_INPUT_TYPE.DUPLICATE == this.inputType
    ) {
      // 新規 or 複製の場合

      // 画面カスタムロードフラグをON(ロード中状態)
      this.loadingState.customLoadStart(
        new LoadData({
          loadingText: '',
          background_color: '',
          opacity: 0.3,
        }),
        LOADING_KEY.GENERATE_INPUT
      );

      this.generateService
        .insert(this.endPoint, generateInputInformation.value)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadEnd(LOADING_KEY.GENERATE_INPUT);

          // 入力レスポンスメッセージを表示
          if (
            this.messageData.generateInputResponseMessage(
              this.inputType,
              response
            )
          ) {
            // 正常終了の場合
            if (window.location.pathname.toLowerCase() == '/pages/platform/c201' && GENERATE_INPUT_TYPE.DUPLICATE == this.inputType) {
              this.reloadID.emit(response.body[0].order_id);
            } else {
              // 更新対象IDにnullをセット
              this.reloadID.emit(null);
            }
          } else {
            // 異常終了の場合

            // 入力フォーム状態初期化
            this.generateInputFormComponent.resetFlag();
          }
        });
    } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType || GENERATE_INPUT_TYPE.APPROVE == this.inputType) {
      // 編集の場合

      // 画面カスタムロードフラグをON(ロード中状態)
      this.loadingState.customLoadStart(
        new LoadData({
          loadingText: '',
          background_color: '',
          opacity: 0.3,
        }),
        LOADING_KEY.GENERATE_INPUT
      );
      // 入力フォームで既存データを更新
      this.generateService
        .update(this.endPoint, this.pkeyId, generateInputInformation.value)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadEnd(LOADING_KEY.GENERATE_INPUT);
          if (this.commonService.checkInvalidValue(response)) {
            // 警告メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );
            // 更新対象IDにnullをセット
            this.reloadID.emit(this.pkeyId);
            // 入力フォーム状態初期化
            this.generateInputFormComponent.resetFlag();
          }
          // 入力レスポンスメッセージを表示
          else if (
            this.messageData.generateInputResponseMessage(
              this.inputType,
              response
            )
          ) {
            // 正常終了の場合

            // 更新対象IDにプライマリキーをセット
            this.reloadID.emit(this.pkeyId);
          }

          else {
            // 異常終了の場合

            // 入力フォーム状態初期化
            this.generateInputFormComponent.resetFlag();
          }
        });
    }
  }

  public return(reloadId) {
    this.reloadID.emit(reloadId);
  }

  public onCloseClick() {
    this.closeModal.emit();
  }

}
